import { mapCompanyType, useFindCompanySuspense } from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/companies/$id.general';
import { EditCompanyForm, GeneralInformationTable } from './components';

export const CompanyGeneralInformation: React.FC = () => {
  const { t } = useTranslation('companyDetailsGeneral');
  const { id } = Route.useParams();
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { data: company } = useFindCompanySuspense(id, {
    query: { select: (data) => mapCompanyType(data.data) },
  });
  const { hasPermission } = usePermissionContext();

  const userCanEditCompany = hasPermission({
    permission: 'ADDRESSBOOK_COMPANIES',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="company-general-information-card">
        <TouringCardHeader>
          <TouringCardTitle>{t('GENERAL_INFORMATION.TITLE')}</TouringCardTitle>
          <TouringCardActions>
            {userCanEditCompany && <EditActionIcon onClick={openModal} />}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <GeneralInformationTable company={company} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        size="lg"
        title={t('EDIT_COMPANY_MODAL.TITLE')}
      >
        <EditCompanyForm company={company} onClose={closeModal} />
      </Modal>
    </>
  );
};
